<template lang="pug">
  extends TableRowBase.pug
</template>

<script>
  import TableRowBase from './TableRowBase.vue';

  export default {
    name: 'TableRowAvgSellingPricePreDisc',
    extends: TableRowBase,
    methods: {
      getCalculatedYtd(yearObj, throughMonth) {
        return this.getRatio(
          this.getYtdByField(yearObj, 'gross_ha_revenue', throughMonth),
          this.getYtdByField(yearObj, 'number_ha_sold', throughMonth),
          0,
        );
      },
    },
  };
</script>
